/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_CtaInputs */

const en_landing_drift_cta = /** @type {(inputs: Landing_Drift_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try a precise edit`)
};

const zh_landing_drift_cta = /** @type {(inputs: Landing_Drift_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试试精准编辑`)
};

/**
* | output |
* | --- |
* | "Try a precise edit" |
*
* @param {Landing_Drift_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_cta = /** @type {((inputs?: Landing_Drift_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_cta(inputs)
	return zh_landing_drift_cta(inputs)
});
export { landing_drift_cta as "landing.drift.cta" }